<template>
  <div class="box">
    <div class="top">
      <div class="title">Quartos</div>
      <button v-if="props.item?.length > 3" @click="show = !show">Ver mais</button>
    </div>
    <div class="content" v-if="props.item?.length > 0">
      <a class="boxItem" v-for="(i, index) in props.item?.slice(0, 3)" :key="index" :href="`https://www.habblet.city/room/${i.id}`" target="_blank">
        <div class="!h-24 !w-24 rounded-md bg-cover" :style="`background-image: url('${i.thumbnailUrl}')`"></div>
        <div class="flex">
          <!-- access_type "doorbell" -->
          <div class="name">{{ i.name }}</div>
          <div class="desc">{{ i.description }}</div>
          <div class="info">
            Lotação: <span>{{ i.maximumVisitors }}</span>
          </div>
          <div class="info">
            Score: <span>{{ i.score }}</span>
          </div>
          <div class="info">
            Tags:
            <span v-for="(tag, index) in i.tags" :key="index">
              <b v-if="index > 0">,</b>{{ tag }}
            </span>
          </div>
        </div>
      </a>
    </div>
  </div>
  <ModRooms v-if="show" :item="props.item" @close="show = !show" />
</template>

<script setup>
import ModRooms from './ModRooms.vue'
import { ref } from 'vue'

const props = defineProps({
  item: {
    type: Array,
    default: () => [],
  },
})
const show = ref(false)
</script>

<style scoped>
.box {
  float: left;
  width: 100%;
  position: relative;
  margin-top: 16px;
  background-color: #f1f1f1;
  border-radius: 12px;
}

.box .top {
  position: relative;
  width: 100%;
  height: 26px;
  display: flex;
  justify-content: space-between;
}

.box .top .title {
  width: 10%;
  height: 20px;
  margin: 15px 0 0 16px;
  color: #444;
  font-size: 14px;
  font-weight: 600;
}

.box .top button {
  float: left;
  width: auto;
  height: 36px;
  background-color: #fff;
  border-radius: 20px;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  font-weight: 600;
  color: #505f6c;
  padding: 0 16px;
  margin: 8px 8px 0 0;
  user-select: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.box .top button:hover {
  background-color: var(--color1);
  color: #fff;
  border-color: #fff;
}

.box .content {
  position: relative;
  width: 100%;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: space-around;
  flex-flow: wrap;
  box-shadow: none;
  background-color: transparent;
}

.box .content .boxItem {
  position: relative;
  width: calc(100% / 3 - 5px);
  height: auto;
  background-color: #fff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  transition: all 0.3s ease;
}

.box .content .boxItem:hover {
  background-color: var(--color1);
  color: #fff;
  border-color: #fff;
}

.box .content .icon {
  width: 60px;
  height: 30px;
  background-image: url('@/assets/icon4.png');
  background-position: center;
  background-repeat: no-repeat;
  margin: 26px 0 0 10px;
}

.box .content .flex {
  width: calc(100% - 80px);
  height: auto;
  margin: 0 0 0 10px;
  display: flex;
  flex-flow: column;
}

.box .content .flex .name {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
}

.box .content .flex .desc {
  width: 100%;
  font-size: 13px;
  font-weight: 500;
}

.box .content .flex .info {
  font-size: 12px;
  width: 100%;
}

.box .content .flex .name,
.box .content .flex .desc,
.box .content .flex .info {
  margin-bottom: 4px;
}

.box .content .flex .name span,
.box .content .flex .desc span,
.box .content .flex .info span {
  font-weight: 600;
}
</style>
